/**
 * PAP v2.0 SKU policy for pepdrive_365.
 * Source: 2.0 for PAP-PepDrive365 Fee Schedule L1 L2 v2.xlsx (Rev 2, 174 SKUs).
 * Labs, held SKUs, and no-fee SKUs must never enter the tracking call.
 */

export const PAP_ALLOWED_SKUS = new Set([
  'TEST-CYP-200MG',
  'SERM-30-1B',
  'SERM-30-3B',
  'SERM-6M',
  'SERM-12M',
  'CRM-RAPA-3M',
  'CRM-B12-INJ-70D',
  'CRM-NAD-INJ-1M',
  'CRM-PT141-INJ-1M',
  'METFORM-6M',
  'METFORM-12M',
  'CRM-GLUTATH-1M',
  'GLUTA-3M',
  'GLUTA-6M',
  'GLUTA-12M',
  'RAPA-1M',
  'RAPA-6M',
  'RAPA-12M',
  'B12-6M',
  'B12-12M',
  'NADINJ-3M',
  'NADINJ-6M',
  'NADINJ-12M',
  'PT141-1M',
  'PT141-3M',
  'PT141-6M',
  'PT141-12M',
  'LDN-6M',
  'LDN-12M',
  'TRE-NIA-HYA-30B',
  'TRE-NIA-HYA-60B',
  'TRE-NIA-HYA-89B',
  'HYD-VIT-NIA',
  'HYD-TRE-VIT-NIA',
  'HYD-TRE-NIA-HYD',
  'SILD-100MG-18-6-3B',
  'SILD-100MG-24-8-3B',
  'SILD-100MG-30-10-3B',
  'SILD-100MG-36-12-3B',
  'SILD-100MG-42-14-3B',
  'SILD-100MG-36-6-6B',
  'SILD-100MG-48-8-6B',
  'SILD-100MG-60-10-6B',
  'SILD-100MG-72-12-6B',
  'SILD-100MG-84-14-6B',
  'SILD-100MG-72-6-12B',
  'SILD-100MG-96-8-12B',
  'SILD-100MG-120-10-12B',
  'SILD-100MG-144-12-12B',
  'SILD-100MG-168-14-12B',
  'SILD-50MG-18-6-3B',
  'SILD-50MG-24-8-3B',
  'SILD-50MG-30-10-3B',
  'SILD-50MG-36-12-3B',
  'SILD-50MG-42-14-3B',
  'SILD-50MG-36-6-6B',
  'SILD-50MG-48-8-6B',
  'SILD-50MG-60-10-6B',
  'SILD-50MG-72-12-6B',
  'SILD-50MG-84-14-6B',
  'SILD-50MG-72-6-12B',
  'SILD-50MG-96-8-12B',
  'SILD-50MG-120-10-12B',
  'SILD-50MG-144-12-12B',
  'SILD-50MG-168-14-12B',
  'TADA-10MG-6-6-1B',
  'TADA-10MG-8-8-1B',
  'TADA-10MG-10-10-1B',
  'TADA-10MG-12-12-1B',
  'TADA-10MG-14-14-1B',
  'TADA-10MG-18-6-3B',
  'TADA-10MG-24-8-3B',
  'TADA-10MG-30-10-3B',
  'TADA-10MG-36-12-3B',
  'TADA-10MG-42-14-3B',
  'TADA-10MG-36-6-6B',
  'TADA-10MG-48-8-6B',
  'TADA-10MG-60-10-6B',
  'TADA-10MG-72-12-6B',
  'TADA-10MG-84-14-6B',
  'TADA-10MG-72-6-12B',
  'TADA-10MG-96-8-12B',
  'TADA-10MG-120-10-12B',
  'TADA-10MG-144-12-12B',
  'TADA-10MG-168-14-12B',
  'TADA-20MG-6-6-1B',
  'TADA-20MG-8-8-1B',
  'TADA-20MG-10-10-1B',
  'TADA-20MG-12-12-1B',
  'TADA-20MG-14-14-1B',
  'TADA-20MG-18-6-3B',
  'TADA-20MG-24-8-3B',
  'TADA-20MG-30-10-3B',
  'TADA-20MG-36-12-3B',
  'TADA-20MG-42-14-3B',
  'TADA-20MG-36-6-6B',
  'TADA-20MG-48-8-6B',
  'TADA-20MG-60-10-6B',
  'TADA-20MG-72-12-6B',
  'TADA-20MG-84-14-6B',
  'TADA-20MG-72-6-12B',
  'TADA-20MG-96-8-12B',
  'TADA-20MG-120-10-12B',
  'TADA-20MG-144-12-12B',
  'TADA-20MG-168-14-12B',
  'TADA-2.5MG-180-30-6B',
  'TADA-2.5MG-30-30-1B',
  'TADA-2.5MG-360-30-12B',
  'TADA-2.5MG-90-30-3B',
  'TADA-5MG-180-30-6B',
  'TADA-5MG-30-30-1B',
  'TADA-5MG-360-30-12B',
  'TADA-5MG-90-30-3B',
  'Semaginj-CR1',
  'SEMA-0.5MG-30-D',
  'SEMA-1MG-30-1B',
  'SEMA-1.5MG-30-1B',
  'SEMA-2MG-30-1B',
  'SEMA-2.5MG-30-1B',
  'TIRZ-CR1',
  'TIRZ-5MG-30-1B',
  'TIRZ-7.5MG-30-1B',
  'TIRZ-10MG-30-1B',
  'TIRZ-12.5MG-30-1B',
  'TIRZ-15MG-30-1B',
  'SG-MAINT-S3-A',
  'SG-MAINT-S4-A',
  'SG-MAINT-S5-A',
  'SG-MAINT-S6-A',
  'SG-STARTER-3M-A',
  'SG-3MT-S2-A',
  'SG-3MT-S3-A',
  'SG-3MT-S4-A',
  'SG-3MT-S5-A',
  'TIRZ-2.5MG-30-6B',
  'TIRZ-CR1-6M',
  'TIRZ-5MG-30-6B',
  'TIRZ-7.5MG-30-6B',
  'TIRZ-10MG-30-6B',
  'TIRZ-12.5MG-30-6B',
  'TIRZ-2.5MG-30-12B',
  'TIRZ-CR1-12M',
  'TIRZ-5MG-30-12B',
  'TIRZ-7.5MG-30-12B',
  'TIRZ-10MG-30-12B',
  'TIRZ-12.5MG-30-12B',
  'Semaginj-CR1-6M',
  'SEMA-0.5MG-30-D-6M',
  'SEMA-1MG-30-6B',
  'SEMA-1.5MG-30-6B',
  'SEMA-2MG-30-6B',
  'SEMA-2.5MG-30-6B',
  'Semaginj-CR1-12M',
  'SEMA-0.5MG-30-D-12M',
  'SEMA-1MG-30-12B',
  'SEMA-1.5MG-30-12B',
  'SEMA-2MG-30-12B',
  'SEMA-2.5MG-30-12B',
  'TZ-MAINT-S2-A',
  'TZ-MAINT-T1-A',
  'TZ-MAINT-T2-A',
  'TZ-MAINT-T3-A',
  'TZ-MAINT-T4-A',
  'TZ-MAINT-T5-A',
  'TZ-MAINT-T6-A',
  'TZ-STARTER-3M-A',
  'FINA-1MG-90-30-3B',
  'FINA-1MG-180-30-6B',
  'FINA-1MG-360-30-12B',
  'SERT-25MG-90-30-3B',
  'SERT-25MG-180-30-6B',
  'SERT-25MG-360-30-12B',
  'PROP-20MG-3B',
  'Omeprazole40mg',
]);

const EXCLUDED_SKU_NEEDLES = [
  "lab",
  "labs",
  "bloodwork",
  "diagnostic",
  "valacyclovir",
  "enclomiphene",
  "enclomid",
  "sublingual",
  "-rdt",
  "_rdt",
  "nad-nasal",
  "nadnasal",
  "nad_nasal",
];

const EXCLUDED_NAME_PATTERNS = [
  /\blabs?\b/i,
  /\bblood\s*work\b/i,
  /\bdiagnostic\b/i,
  /valacyclovir/i,
  /enclomiphene/i,
  /enclomid/i,
  /oral\s+semaglutide/i,
  /semaglutide\s+drops/i,
  /tirzepatide.{0,40}(sublingual|rdt)/i,
  /(sublingual|rdt).{0,40}tirzepatide/i,
  /nad\+?\s*nasal/i,
  /nasal\s*nad/i,
  /metformin.{0,24}3\s*-?\s*mo/i,
  /\bldn\b.{0,24}3\s*-?\s*mo/i,
  /\bb12\b.{0,24}3\s*-?\s*mo/i,
];

export function getProductSku(product) {
  if (!product || typeof product !== "object") return "";
  const raw =
    product.product_sku ??
    product.sku ??
    product.sku_code ??
    product.product_code ??
    "";
  return String(raw).trim();
}

function skuIsOnFeeSheet(sku) {
  if (!sku) return false;
  if (PAP_ALLOWED_SKUS.has(sku)) return true;
  const lower = sku.toLowerCase();
  for (const allowed of PAP_ALLOWED_SKUS) {
    if (allowed.toLowerCase() === lower) return true;
  }
  return false;
}

function textBlob(product) {
  return [
    getProductSku(product),
    product?.product_name,
    product?.name,
    product?.product_title,
    product?.category,
  ]
    .filter(Boolean)
    .join(" ")
    .toLowerCase();
}

export function isExcludedFromPapTracking(product) {
  const sku = getProductSku(product);
  const skuLower = sku.toLowerCase();
  const blob = textBlob(product);
  const category = String(product?.product_category_name || "").toLowerCase();

  if (category === "labs") {
    return true;
  }
  if (sku && !skuIsOnFeeSheet(sku)) {
    return true;
  }
  if (EXCLUDED_SKU_NEEDLES.some((needle) => skuLower.includes(needle))) {
    return true;
  }
  if (EXCLUDED_NAME_PATTERNS.some((re) => re.test(blob))) {
    return true;
  }
  return false;
}

/**
 * PAP pays a flat $ per SKU. totalCost is list price (coupon must not change the fee).
 * Product ID prefers the Excel SKU so PAP commission rules match the 2.0 sheet.
 */
export function getPapSaleLineItems(products) {
  return (products ?? [])
    .filter((product) => product && !isExcludedFromPapTracking(product))
    .map((product) => {
      const sku = getProductSku(product);
      const productId = sku || String(product.product_id ?? "");
      const listPrice = parseFloat(product.product_price || 0);
      return {
        productId,
        totalCost: Number.isFinite(listPrice)
          ? Math.round(listPrice * 100) / 100
          : 0,
      };
    })
    .filter((item) => item.productId);
}

/** PAP spec §6: PARTNER personal codes must not create a commission. */
export function shouldSkipPapSaleForCoupon(code) {
  return String(code || "")
    .trim()
    .toUpperCase()
    .startsWith("PARTNER");
}

/**
 * PAP spec §9: sale fires when Rx is sent to pharmacy AND the card is charged.
 * Do not treat checkout success as completed.
 */
export function orderIsPapComplete(orderPayload) {
  if (!orderPayload || typeof orderPayload !== "object") return false;
  if (Number(orderPayload.status) !== 1) return false;

  const pharmacyKeys = [
    "rx_sent",
    "rx_sent_to_pharmacy",
    "sent_to_pharmacy",
    "pharmacy_sent",
    "prescription_sent",
  ];
  const chargeKeys = [
    "card_charged",
    "payment_captured",
    "charged",
    "payment_status",
  ];

  const pharmacyOk = pharmacyKeys.some((k) => {
    const v = orderPayload[k];
    return v === true || v === 1 || v === "1" || String(v).toLowerCase() === "sent";
  });
  const chargeOk = chargeKeys.some((k) => {
    const v = orderPayload[k];
    return (
      v === true ||
      v === 1 ||
      v === "1" ||
      String(v).toLowerCase() === "captured" ||
      String(v).toLowerCase() === "charged"
    );
  });

  return pharmacyOk && chargeOk;
}

